/**
 * @desc 根据系统单号获取订单包裹
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.listPackageBySoOrderNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/systemOrderPackage/listPackageBySoOrderNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
